import React, { useEffect, useState} from "react";
import { useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import iconLeftArrow from "../../../assets/images/icon-left-arrow.png"
import { Button } from "react-bootstrap";
import "react-datepicker/dist/react-datepicker.css";
import "../CalibrageEnCours/calibrageEnCours.css"
import EvaluationComparedCard from "./EvaluationComparedCard";
import { getEvalsToCompare } from "../../../redux/actions/evaluation";
import { useLocation } from 'react-router-dom';
import RingLoaderShared from "../../../shared/RingLoader/RingLoader";
const ListEvalsCompared = (props) => {
  const history = useHistory();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const ids = queryParams.get('ids')?.split(',') || [];
  const { comparedevals } = useSelector((state) => state.evaluation);
  const evalgrid=comparedevals[0]?.eval
  const grille=evalgrid?.Grid
  let val = window.location.search;
  const [selectedEval, setSelectedEval] = useState();
  const [loading, setLoading] = useState(true);
  const [displayInfoBar, setDisplayInfoBar] = useState({
    displayInfoBar: false,
    id: 0,
  });
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(getEvalsToCompare([ids])).finally(() => setLoading(false)
    );
  }, [dispatch]);
  
  return (
    <>
      <div>
      <div id="nouvelle-eval-right-side" className="align-divs-vertical">
        <div className="container-of-right-side">
        <div id="nouvelle-eval-bar">
          <div className="div-bar">
            <div
              onClick={() => {
                displayInfoBar.displayInfoBar = false;
                setDisplayInfoBar({ ...displayInfoBar });
                history.goBack();
              }}
              className="container-icon-arraw-left"
            >
              <img  alt="go back" src={iconLeftArrow} width="20" height="20" />
            </div>
            <h5 className="add-eval-title" style={{ marginBottom: "0" }}>
              {" "}
              Comparaison{" "}
            </h5>
          </div>
          <div className="div-bar">
            <div className="grille-name">
              <span>{grille?.name}</span>
            </div>
          </div>
        </div>
        <div className="container container-calibrage-encours">
        {
          loading?  
          <>
            <RingLoaderShared/></>
          : comparedevals?.filter((evaluation)=> !evaluation.eval.isRef)?.map((evaluation, index) => (
          <React.Fragment key={evaluation.eval.id}>
            <div className="detailCard" 
            >
              <EvaluationComparedCard 
              CriteriaGroup={evaluation.CriteriaGroup} 
              evaluation={evaluation.eval} 
              grille={evaluation?.eval?.Grid} 
              isSelected={evaluation.eval.id === selectedEval}
              key={evaluation.eval.id}
              />
            </div>
            {index < comparedevals.filter((evaluation)=> !evaluation.eval.isRef).length - 1 && (
              <div className="separator-container">
                <div className="vl"></div>
                <div className="circle-vs">
                  <span>VS</span>
                </div>
                <div className="vl"></div>
              </div>
            )}
          </React.Fragment>
        ))
        }
        {}
            </div>
            <div className="container-buttons_eval">
              <Button
                variant="primary"
                className="buttons"
                style={{
                  backgroundColor: "white",
                  borderColor: "#5800e2",
                  color: "#5800e2",
                  float: "right",
                }}
                onClick={() => {
                  history.goBack();
                }}
              >
                Retour
              </Button>
            </div>
          </div>   
          </div>         
      </div>
      
    </>
  );
};
export default ListEvalsCompared

